import { Route } from "nextjs-routes";
import React, { ReactNode, useEffect, useState } from "react";

import { BackButton } from "./BackButton";
import { ShareButton } from "./ShareButton";
import { IconArrow } from "components/Icon/IconArrow";
import { useRouter } from "next/router";
import { useRedirectPreviousPath } from "modules/Auth/authHooks";
import { IconFilter } from "components/Icon/IconFilter";

import { Step } from "react-joyride";
import { useSetState } from "react-use";
import dynamic from "next/dynamic";
import useTranslation from "next-translate/useTranslation";
import { useCourseQuizStore } from "modules/Course/courseQuizStore";
import { useAssignmentStore } from "modules/Course/courseAssignmentStore";

const JoyRideNoSSR = dynamic(() => import("react-joyride"), { ssr: false });

export type Props = {
  isQuizOrIsAssignment?: boolean;
  isLeaderboard?: boolean;
  title?: ReactNode;
  titleLesson?: string;
  children?: ReactNode;
  className?: string;
  titleClassName?: string;
  withBackButton?: boolean;
  backTo?: Route;
  quizBackToCourse?: boolean;
  assignmentBackToCourse?: boolean;
  // assignmentBackToCourse?: Route;
  // quizBackToCourse?: Route;
  onShare?(): void;
  onBackClick?(): void;
  onFilter?(): void;
  withArrowButton?: boolean;
};

interface State {
  run: boolean;
  steps: Step[];
}

export const PageHeader: React.FC<Props> = (props) => {
  const {
    isQuizOrIsAssignment = false,
    isLeaderboard = false,
    title,
    titleLesson = null,
    children,
    className = "",
    titleClassName = "",
    withBackButton,
    backTo,
    quizBackToCourse = false,
    assignmentBackToCourse = false,
    onShare,
    onBackClick,
    onFilter,
    withArrowButton,
  } = props;

  const router = useRouter();
  const { previousPath } = useRedirectPreviousPath();
  const { t } = useTranslation("tags");
  const { onCloseModal } = useCourseQuizStore();
  const { onCloseModal: onCloseModalAssignment } = useAssignmentStore();

  const onClickArrow = () => {
    if (backTo) {
      router.replace(backTo);
    } else if (quizBackToCourse) {
      onCloseModal(router);
      // (router as any).push(quizBackToCourse);
    } else if (assignmentBackToCourse) {
      onCloseModalAssignment(router);
      // (router as any).push(assignmentBackToCourse);
    } else {
      // If any trigger from my-class and user not logged in
      var isUsingLoginAuthorize = ["my-class"].includes(previousPath);

      // Kursus terbaik tentang
      var isHomeUrl = previousPath === "home";

      router.push({
        pathname: isUsingLoginAuthorize || isHomeUrl ? "/" : previousPath,
      });
    }
  };

  const [{ run, steps }, setState] = useSetState<State>({
    run: false,
    steps: [
      {
        content: (
          <div className="text-left">
            <div className="text-b2 text-neutral-70 font-medium">
              Pasang filter sesuai kebutuhanmu
            </div>
            <div className="text-c1 text-neutral-70 font-light">
              Sekarang kamu bisa mencari kursus yang kamu butuhkan dengan filter
            </div>
          </div>
        ),
        floaterProps: {
          disableAnimation: true,
        },
        placement: "bottom-end",
        styles: {
          options: {
            width: 300,
            zIndex: 1000,
          },
          tooltipContent: {
            padding: "unset",
          },
        },
        offset: 1,
        spotlightPadding: 5,
        target: ".filter-popup",
        hideFooter: true,
        disableBeacon: true,
      },
    ],
  });

  useEffect(() => {
    const isClosedGuide = localStorage.getItem("isCloseGuide");
    if (onFilter && isClosedGuide) {
      setState({ run: false });
    } else if (onFilter && !isClosedGuide) {
      localStorage.setItem("isCloseGuide", "true");
      setState({ run: true });
    }
  }, []);

  const month = new Date().toLocaleString("default", { month: "long" });

  return (
    <div
      className={`z-10 h-60 px-16 flex items-center gap-16 border-b border-neutral20_to_dark30 sticky top-0 bg-white ${className}`}
    >
      {onBackClick && (
        <div onClick={onBackClick} className="cursor-pointer">
          <IconArrow size={24} />
        </div>
      )}

      {/*@ts-ignore */}
      {withBackButton ? <BackButton backTo={() => router.back()} /> : null}
      {withArrowButton ? (
        <div onClick={() => router.back()} className="cursor-pointer">
          <IconArrow isCaret={true} direction="left" color="#000" size={24} />
        </div>
      ) : null}
      {title ? (
        <h3 className={`text-h4 font-medium ${titleClassName}`}>
          {t(title.toString())}
        </h3>
      ) : null}
      {isQuizOrIsAssignment && (
        <h3 className={`text-h4 font-medium ${titleClassName}`}>
          {titleLesson}
        </h3>
      )}
      {isLeaderboard && (
        <h3 className={`text-h4 font-medium ${titleClassName}`}>
          {month} Leaderboard
        </h3>
      )}
      {children ? children : null}
      {onShare && <ShareButton onShare={onShare} />}
      {onFilter && (
        <>
          <JoyRideNoSSR run={run} steps={steps} />
          <div
            onClick={onFilter}
            className="filter-popup cursor-pointer my-auto mr-0 ml-auto rounded-md p-8 bg-light_neutral10_to_dark_neutral50"
          >
            <IconFilter color="#2A1060" />
          </div>
        </>
      )}
    </div>
  );
};
